var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "select-city-box" },
    [
      _c(
        "div",
        { staticClass: "select-history" },
        [
          _c("h3", { staticClass: "flexBox" }, [
            _c("span", { staticClass: "flexItem" }, [_vm._v("当前位置")]),
            _vm._v(" "),
            _c("i", { staticClass: "icon icon-refresh" }),
            _vm._v(" "),
            _c("span", { on: { click: _vm.refreshLocation } }, [
              _vm._v("重新定位")
            ])
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "s-city position-city",
              on: {
                click: function($event) {
                  return _vm.selectCity(
                    _vm.positionCity,
                    _vm.positionCity + "市"
                  )
                }
              }
            },
            [
              _c("i", { staticClass: "icon icon-h-location" }),
              _vm._v(" "),
              _c("span", {
                staticClass: "position",
                domProps: { textContent: _vm._s(_vm.positionCity) }
              })
            ]
          ),
          _vm._v(" "),
          _vm.hasStorage
            ? [
                _c("h3", { staticClass: "history-title" }, [
                  _vm._v("历史访问城市")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "history-list flexBox" },
                  [
                    _vm._l(_vm.storageListFilter, function(list) {
                      return _c("span", {
                        staticClass: "s-city",
                        domProps: { textContent: _vm._s(list) },
                        on: {
                          click: function($event) {
                            return _vm.selectCity(list, list + "市")
                          }
                        }
                      })
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "s-city s-city-blank" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "s-city s-city-blank" })
                  ],
                  2
                )
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm._l(_vm.cityList, function(list, index) {
        return [
          _c("city-letter-list", {
            attrs: {
              lists: list.CityList,
              id: "cityletterlist_" + index,
              letter: list.FirstChar
            },
            on: { selectCity: _vm.selectCity }
          })
        ]
      }),
      _vm._v(" "),
      _c("div", { staticClass: "letter-tools flexBox" }, [
        _c(
          "div",
          { staticClass: "letter-box-wrap" },
          _vm._l(_vm.cityList, function(letter, index) {
            return _c(
              "div",
              {
                staticClass: "letter-box",
                attrs: { id: "letterbox" + index },
                on: {
                  click: function($event) {
                    return _vm.selectLetter(index)
                  },
                  touchmove: function($event) {
                    return _vm.mousemoveletter(index, $event)
                  }
                }
              },
              [
                _c("span", {
                  staticClass: "letter",
                  domProps: { textContent: _vm._s(letter.FirstChar) }
                })
              ]
            )
          }),
          0
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-623b2ea1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-623b2ea1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/selectCity.vue
// module id = null
// module chunks = 